import { create as createLocalStorageCache } from './cache/localStorage';
import { create as createRemote } from './remote';
import { Resources } from './types/Resources';

export interface Backend {
  fetch: (locale: string) => Promise<Resources | null>;
}

export const create = (packageName: string, namespace: string) => {
  const localStorageCache = createLocalStorageCache(packageName, namespace);
  const remote = createRemote(packageName, namespace);

  const fetch = async (locale: string): Promise<Resources | null> => {
    const cachedResources = localStorageCache.read(locale);

    if (cachedResources) {
      return cachedResources;
    }

    try {
      const fetchedResources = await remote.fetch(locale);

      localStorageCache.write(locale, fetchedResources);

      return fetchedResources;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(`Could not load remote resources for "${packageName}" in "${locale}".`);
      return null;
    }
  };

  return {
    fetch,
  };
};
